import { useLocation } from 'react-router-dom';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';

const useLetterMeta = () => {
    const location = useLocation();
    const { data: letter } = useCurrentLetter();

    const letterBody = letter.body ?? '';
    const isBodyEmpty = letterBody.length === 0;
    const isEasySend = letter.settings.send_to_print_and_mail_service;

    const recipientCount = letter.recipient_count ?? 0;
    const noRecipientCount = recipientCount === 0;

    const isOnConfirm = location.pathname.includes('confirm');
    const isOnEditor = location.pathname.includes('compose');

    return {
        isBodyEmpty,
        noRecipientCount,
        isOnConfirm,
        isOnEditor,
        isEasySend,
    };
};

export { useLetterMeta };
